import { render, staticRenderFns } from "./RegionStatusBar.vue?vue&type=template&id=482359a5"
import script from "./RegionStatusBar.js?vue&type=script&lang=js&external"
export * from "./RegionStatusBar.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports